export default {
    // 中
    zhCN: {
        Create_Engineer_Management_Organization: '新建工程师管理组织',
        Edit_Engineer_Management_Organization: '编辑工程师管理组织',
        engineer: '工程师',
        management_organization: '管理组织',
    },
    // 英
    enUS: {
        Create_Engineer_Management_Organization: 'Create Engineer Management Organization',
        Edit_Engineer_Management_Organization: 'Edit Engineer Management Organization',
        engineer: 'Engineer',
        management_organization: 'Management Organization',
    },
    // 德
    deDE: {
        Create_Engineer_Management_Organization: 'Ingenieur-Management-Organisation erstellen',
        Edit_Engineer_Management_Organization: 'Ingenieur-Management-Organisation bearbeiten',
        engineer: 'Ingenieur',
        management_organization: 'Managementorganisation',
    },
    // 法
    frFR: {
        Create_Engineer_Management_Organization: 'Créer une organisation de gestion des ingénieurs',
        Edit_Engineer_Management_Organization: 'Modifier l\'organisation de gestion des ingénieurs',
        engineer: 'Ingénieur',
        management_organization: 'Organisation de gestion',
    },
    // 意大利
    itIT: {
        Create_Engineer_Management_Organization:
            'Creare un\'organizzazione di gestione degli ingegneri',
        Edit_Engineer_Management_Organization:
            'Modifica organizzazione di gestione degli ingegneri',
        engineer: 'Ingegnere',
        management_organization: 'Organizzazione di gestione',
    },
    // 荷兰
    nlNL: {
        Create_Engineer_Management_Organization: 'Ingenieursbeheerorganisatie aanmaken',
        Edit_Engineer_Management_Organization: 'Ingenieursbeheerorganisatie bewerken',
        engineer: 'Ingenieur',
        management_organization: 'Managementorganisatie',
    },
    // 越南
    viVN: {
        Create_Engineer_Management_Organization: 'Tạo Tổ chức Quản lý Kỹ sư',
        Edit_Engineer_Management_Organization: 'Chỉnh sửa Tổ chức Quản lý Kỹ sư',
        engineer: 'Kỹ sư',
        management_organization: 'Tổ chức quản lý',
    },
    // 西班牙
    esES: {
        Create_Engineer_Management_Organization: 'Crear organización de gestión de ingenieros',
        Edit_Engineer_Management_Organization: 'Editar organización de gestión de ingenieros',
        engineer: 'Ingeniero',
        management_organization: 'Organización de gestión',
    },
    // 葡萄牙
    ptBR: {
        Create_Engineer_Management_Organization: 'Criar Organização de Gestão de Engenheiros',
        Edit_Engineer_Management_Organization: 'Editar Organização de Gestão de Engenheiros',
        engineer: 'Engenheiro',
        management_organization: 'Organização de gestão',
    },
    // 波兰
    plPL: {
        Create_Engineer_Management_Organization: 'Utwórz organizację zarządzania inżynierami',
        Edit_Engineer_Management_Organization: 'Edytuj organizację zarządzania inżynierami',
        engineer: 'Inżynier',
        management_organization: 'Organizacja zarządzania',
    },
    // 土耳其
    trTR: {
        Create_Engineer_Management_Organization: 'Mühendis Yönetim Organizasyonu Oluştur',
        Edit_Engineer_Management_Organization: 'Mühendis Yönetim Organizasyonunu Düzenle',
        engineer: 'Mühendis',
        management_organization: 'Yönetim Organizasyonu',
    },
    // 捷克语
    csCZ: {
        Create_Engineer_Management_Organization: 'Vytvořte organizaci řízení techniků',
        Edit_Engineer_Management_Organization: 'Upravit organizaci řízení techniků',
        engineer: 'Technik',
        management_organization: 'Organizace řízení',
    },
    // 匈牙利语
    huHU: {
        Create_Engineer_Management_Organization: 'Szerelő felügyeleti szervezet létrehozása',
        Edit_Engineer_Management_Organization: 'Szerelő felügyeleti szervezet szerkesztése',
        engineer: 'Szerelő',
        management_organization: 'Felügyeleti szervezet',
    },
    // 俄罗斯语
    ruRU: {
        Create_Engineer_Management_Organization: 'Создать организацию управления инженерами',
        Edit_Engineer_Management_Organization: 'Редактировать организацию управления инженерами',
        engineer: 'Инженер',
        management_organization: 'Организация управления',
    },
    // 沙特阿拉伯
    arSA: {
        Create_Engineer_Management_Organization: 'إنشاء منظمة إدارة مهندسين جديدة',
        Edit_Engineer_Management_Organization: 'تعديل منظمة إدارة المهندسين',
        engineer: 'مهندس',
        management_organization: 'منظمة الإدارة',
    },
    // 保加利亚
    bgBG: {
        Create_Engineer_Management_Organization:
            'Създаване на нова организация за управление на инженери',
        Edit_Engineer_Management_Organization:
            'Редактиране на организацията за управление на инженери',
        engineer: 'инженер',
        management_organization: 'управляваща организация',
    },
    // 丹麦语
    daDK: {
        Create_Engineer_Management_Organization: 'Opret ny ingeniørledelsesorganisation',
        Edit_Engineer_Management_Organization: 'Redigér ingeniørledelsesorganisation',
        engineer: 'ingeniør',
        management_organization: 'ledelsesorganisation',
    },
    // 芬兰语
    fiFI: {
        Create_Engineer_Management_Organization: 'Luo uusi insinöörien hallintayksikkö',
        Edit_Engineer_Management_Organization: 'Muokkaa insinöörien hallintayksikköä',
        engineer: 'insinööri',
        management_organization: 'hallintayksikkö',
    },
    // 繁体中文台湾
    zhTW: {
        Create_Engineer_Management_Organization: '新建工程師管理組織',
        Edit_Engineer_Management_Organization: '編輯工程師管理組織',
        engineer: '工程師',
        management_organization: '管理組織',
    },
    // 克罗地亚
    hrHR: {
        Create_Engineer_Management_Organization:
            'Stvori novu organizaciju za upravljanje inženjerima',
        Edit_Engineer_Management_Organization: 'Uredi organizaciju za upravljanje inženjerima',
        engineer: 'inženjer',
        management_organization: 'upravljačka organizacija',
    },
    // 拉脱维亚
    lvLV: {
        Create_Engineer_Management_Organization:
            'Izveidot jaunu inženieru pārvaldības organizāciju',
        Edit_Engineer_Management_Organization: 'Rediģēt inženieru pārvaldības organizāciju',
        engineer: 'inženieris',
        management_organization: 'pārvaldības organizācija',
    },
    // 立陶宛
    ltLT: {
        Create_Engineer_Management_Organization: 'Sukurti naują inžinierių valdymo organizaciją',
        Edit_Engineer_Management_Organization: 'Redaguoti inžinierių valdymo organizaciją',
        engineer: 'inžinierius',
        management_organization: 'valdymo organizacija',
    },
    // 罗马尼亚
    roRO: {
        Create_Engineer_Management_Organization:
            'Creează o nouă organizație de management pentru ingineri',
        Edit_Engineer_Management_Organization: 'Editează organizația de management pentru ingineri',
        engineer: 'inginer',
        management_organization: 'organizație de management',
    },
    // 挪威博克马尔
    nbNO: {
        Create_Engineer_Management_Organization:
            'Opprett ny organisasjon for ingeniøradministrasjon',
        Edit_Engineer_Management_Organization: 'Rediger organisasjon for ingeniøradministrasjon',
        engineer: 'ingeniør',
        management_organization: 'administrasjonsorganisasjon',
    },
    // 葡萄牙语巴西
    ptBX: {
        Create_Engineer_Management_Organization: 'Criar nova organização de gestão de engenheiros',
        Edit_Engineer_Management_Organization: 'Editar organização de gestão de engenheiros',
        engineer: 'engenheiro',
        management_organization: 'organização de gestão',
    },
    // 瑞典语
    svSE: {
        Create_Engineer_Management_Organization: 'Skapa ny ingenjörsledningsorganisation',
        Edit_Engineer_Management_Organization: 'Redigera ingenjörsledningsorganisation',
        engineer: 'ingenjör',
        management_organization: 'ledningsorganisation',
    },
    // 斯洛伐克
    skSK: {
        Create_Engineer_Management_Organization:
            'Vytvoriť novú organizačnú jednotku pre riadenie inžinierov',
        Edit_Engineer_Management_Organization:
            'Upraviť organizačnú jednotku pre riadenie inžinierov',
        engineer: 'inžinier',
        management_organization: 'manažérska organizácia',
    },
    // 斯洛文尼亚
    slSI: {
        Create_Engineer_Management_Organization:
            'Ustvari novo organizacijo za upravljanje inženirjev',
        Edit_Engineer_Management_Organization: 'Uredi organizacijo za upravljanje inženirjev',
        engineer: 'inženir',
        management_organization: 'upravna organizacija',
    },
    // 泰语
    thTH: {
        Create_Engineer_Management_Organization: 'สร้างองค์กรจัดการวิศวกรใหม่',
        Edit_Engineer_Management_Organization: 'แก้ไของค์กรจัดการวิศวกร',
        engineer: 'วิศวกร',
        management_organization: 'องค์กรจัดการ',
    },
    // 乌克兰语
    ukUA: {
        Create_Engineer_Management_Organization:
            'Створити нову організацію з управління інженерами',
        Edit_Engineer_Management_Organization: 'Редагувати організацію з управління інженерами',
        engineer: 'інженер',
        management_organization: 'керівна організація',
    },
    // 希腊语
    elGR: {
        Create_Engineer_Management_Organization: 'Δημιουργία νέου οργανισμού διαχείρισης μηχανικών',
        Edit_Engineer_Management_Organization: 'Επεξεργασία οργανισμού διαχείρισης μηχανικών',
        engineer: 'μηχανικός',
        management_organization: 'οργανισμός διαχείρισης',
    },
    // 爱沙尼亚
    etEE: {
        Create_Engineer_Management_Organization: 'Loo uus inseneride haldusorganisatsioon',
        Edit_Engineer_Management_Organization: 'Muuda inseneride haldusorganisatsiooni',
        engineer: 'insener',
        management_organization: 'haldusorganisatsioon',
    },
    // 哈萨克
    kkKZ: {
        Create_Engineer_Management_Organization: 'Инженерлерді басқару ұйымын жаңадан құру',
        Edit_Engineer_Management_Organization: 'Инженерлерді басқару ұйымын өңдеу',
        engineer: 'инженер',
        management_organization: 'басқару ұйымы',
    },
    // 希伯来语
    heIL: {
        Create_Engineer_Management_Organization: 'יצירת ארגון חדש לניהול מהנדסים',
        Edit_Engineer_Management_Organization: 'עריכת ארגון ניהול מהנדסים',
        engineer: 'מהנדס',
        management_organization: 'ארגון ניהול',
    },
};
